import { useState } from 'react';
import './Design.scss';
import Typography from './Typography/Typography';
import Text from '../../common/Text/Text';
import Inputs from './Inputs/Inputs';
import Buttons from './Buttons/Buttons';
import Banners from './Banners/Banners';

const Design = () => {
  const [section, setSection] = useState<string>('typography');
  return (
    <div className="design">
      <Text type="header">Alpha Taxi Kiosk design system</Text>
      <div className="sections">
        <input
          type="radio"
          id="typography"
          name="section"
          value="typography"
          checked={section === 'typography'}
          onChange={e => setSection(e.target.value)}
        />
        <label htmlFor="typography">Typography</label>

        <input
          type="radio"
          id="fields"
          name="section"
          value="fields"
          checked={section === 'fields'}
          onChange={e => setSection(e.target.value)}
        />
        <label htmlFor="fields">Fields & Inputs</label>

        <input
          type="radio"
          id="buttons"
          name="section"
          value="buttons"
          checked={section === 'buttons'}
          onChange={e => setSection(e.target.value)}
        />
        <label htmlFor="buttons">Buttons</label>

        <input
          type="radio"
          id="banners"
          name="section"
          value="banners"
          checked={section === 'banners'}
          onChange={e => setSection(e.target.value)}
        />
        <label htmlFor="banners">Banners & Alerts</label>
      </div>

      <div className="content">
        {section === 'typography' && <Typography />}
        {section === 'fields' && <Inputs />}
        {section === 'buttons' && <Buttons />}
        {section === 'banners' && <Banners />}
      </div>
    </div>
  );
};

export default Design;
